import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL, { isProdEnv, secretEncryptionKey } from "../../ServiceModule/Service";
import encryptJSON from "../../ServiceModule/Encrypt";
import moment from 'moment-timezone';
import { storeToken } from "../../LoginModule/LoginUtility";
// Async Thunk for login
export const loginUser = createAsyncThunk(
  "auth/login",
  async (userData, { rejectWithValue }) => {
    let data = null
    if (isProdEnv == "true") {
      const encryptedPayload = encryptJSON(userData, secretEncryptionKey);
      data = {
        element: encryptedPayload,
      }
    }
    else {
      data = userData
    }
    try {
      const response = await axios.post(
        `${API_URL}/api/users/userLogin`,
        data
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.data && typeof error.response.data.message === "string" && error.response.data.message.includes("Account is locked. Try again later")) {
        return error.response.data;
      }
      else if (error.response && error.response.data && typeof error.response.data.message === "string" && error.response.data.message.includes("Account is locked. Please contact to system administrator")) {
        return error.response.data;
      }
      else {
        return rejectWithValue(error.response?.data || "An error occurred");
      }
    }

  }
);

export const registerUser = createAsyncThunk(
  "auth/register",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${API_URL}/api/users/createUser`,
        userData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const registerUserWithRoleUser = createAsyncThunk(
  "auth/registerWithRoleUsr",
  async (userData, { rejectWithValue }) => {
    let data = null
    if (isProdEnv == "true") {
      const encryptedPayload = encryptJSON(userData, secretEncryptionKey);
      data = {
        element: encryptedPayload,
      }
    }
    else {
      data = userData
    }
    try {
      const response = await axios.post(
        `${API_URL}/api/users/createUserWithRoleUser`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const UserUpdate = createAsyncThunk(
  "auth/update",
  async (userData, { rejectWithValue }) => {
    try {
      let data = null
      if (isProdEnv == "true") {
        const encryptedPayload = encryptJSON(userData, secretEncryptionKey);
        data = {
          element: encryptedPayload,
        }
      }
      else {
        data = userData
      }
      const response = await axios.post(
        `${API_URL}/api/users/updateUserEmail`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const UserUpdateWithUserRole = createAsyncThunk(
  "auth/updateUserEmailWithUserRole",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${API_URL}/api/users/updateUserEmailWithUserRole`,
        userData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async Thunk for verifying user with email
export const verifyUserWithEmail = createAsyncThunk(
  "auth/verifyUserWithEmail",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${API_URL}/api/users/emailVerification`,
        userData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Auth slice
const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    isAuthenticated: false,
    loading: false,
    error: null,
  },
  reducers: {




  },
  extraReducers: (builder) => {
    // Handle login
    builder.addCase(loginUser.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(loginUser.fulfilled, (state, action) => {
      state.loading = false;
      state.isAuthenticated = true;
      state.user = action.payload;
      state.token = action.payload.token;
      storeToken(action?.payload?.token)
    });
    builder.addCase(loginUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Handle registration
    builder.addCase(registerUser.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(registerUser.fulfilled, (state, action) => {
      state.loading = false;
      state.isAuthenticated = true;
      state.user = action.payload;
    });
    builder.addCase(registerUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(registerUserWithRoleUser.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(registerUserWithRoleUser.fulfilled, (state, action) => {
      state.loading = false;
      state.isAuthenticated = true;
      state.user = action.payload;
    });
    builder.addCase(registerUserWithRoleUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Handle registration
    builder.addCase(UserUpdate.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(UserUpdate.fulfilled, (state, action) => {
      state.loading = false;
      state.isAuthenticated = true;
      state.user = action.payload;
    });
    builder.addCase(UserUpdate.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(UserUpdateWithUserRole.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(UserUpdateWithUserRole.fulfilled, (state, action) => {
      state.loading = false;
      state.isAuthenticated = true;
      state.user = action.payload;
    });
    builder.addCase(UserUpdateWithUserRole.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Handle email verification
    builder.addCase(verifyUserWithEmail.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(verifyUserWithEmail.fulfilled, (state, action) => {
      state.loading = false;
      state.user = action.payload;
    });
    builder.addCase(verifyUserWithEmail.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
